module.exports = __webpack_public_path__ + "img/habitat_4.32704c03.jpg";